import { FC, memo } from 'react'
import { ButtonProps } from '@chakra-ui/react'

import { ButtonWithPermission } from 'components/validators'
import getAssets from 'utils/assets/getAssets'

type Props = ButtonProps & {
  permissions?: (string | undefined)[]
  customDisableCondition?: boolean
}

const CreateButtonWithPermission: FC<Props> = ({ customDisableCondition = null, permissions, children, ...props }) => {
  const CreateIcon = getAssets('Icon', 'Create')

  return (
    <ButtonWithPermission
      customDisableCondition={customDisableCondition}
      permissions={permissions}
      leftIcon={<CreateIcon />}
      {...props}
    >
      {children}
    </ButtonWithPermission>
  )
}

export default memo(CreateButtonWithPermission)
